export const selfDescriptionsCz = {
  selfDescriptions: {
    'Motivator': 'Motivátor',
    'Team Player': 'Týmový hráč',
    'Analysis': 'Analytik',
    'Solo Player': 'Individualista'
  }
};